import React from 'react';
import { Paper, Typography, Box, Button, Fade, alpha, useTheme } from '@mui/material';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import PsychologyIcon from '@mui/icons-material/Psychology';

interface EmptyAnalysisStateProps {
  onAnalyze: () => void;
}

const EmptyAnalysisState: React.FC<EmptyAnalysisStateProps> = ({ onAnalyze }) => {
  const theme = useTheme();

  return (
    <Fade in={true}>
      <Paper
        elevation={0}
        sx={{
          p: 6,
          bgcolor: 'transparent',
          borderRadius: 3,
          border: `1px dashed ${alpha(theme.palette.primary.main, 0.3)}`,
          background: alpha(theme.palette.background.paper, 0.7),
          textAlign: 'center',
          transition: 'all 0.3s ease-in-out',
          '&:hover': { borderColor: theme.palette.primary.main, boxShadow: '0 8px 32px rgba(0,0,0,0.08)' },
        }}
      >
        <Box
          sx={{
            width: 120,
            height: 120,
            bgcolor: alpha(theme.palette.primary.main, 0.08),
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 4,
            boxShadow: `0 0 0 8px ${alpha(theme.palette.primary.main, 0.03)}`,
          }}
        >
          <PsychologyIcon sx={{ fontSize: 64, color: theme.palette.primary.main, opacity: 0.9 }} />
        </Box>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, color: theme.palette.text.primary, letterSpacing: '-0.01em', mb: 2 }}>
          No Analysis Available
        </Typography>
        <Typography variant="body1" color="text.secondary" component="p" sx={{ maxWidth: 700, mx: 'auto', mb: 5, fontSize: '1.05rem', lineHeight: 1.6 }}>
          Click the "Analyze Property" button to generate AI-powered insights, market context, valuation estimates, and strategic recommendations for this hotel.
        </Typography>
        <Button
          variant="outlined"
          color="primary"
          onClick={onAnalyze}
          startIcon={<AnalyticsIcon />}
          sx={{
            borderRadius: 2,
            px: 4,
            py: 1.2,
            borderWidth: 1.5,
            textTransform: 'none',
            fontSize: '0.95rem',
            fontWeight: 600,
            '&:hover': { borderWidth: 1.5, boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.2)}`, transform: 'translateY(-2px)', transition: 'all 0.2s ease-in-out' },
          }}
        >
          Analyze Property
        </Button>
      </Paper>
    </Fade>
  );
};

export default EmptyAnalysisState;